import { AspectFilterGlobal } from './categories/AspectFilterGlobal';
import { AspectFilterByNameMultiple } from './categories/AspectFilterByNameMultiple';
import { AspectFilterByName } from './categories/AspectFilterByName';
import { RegistryRoof } from '../RegistryRoof';
export class AspectFilterRegistry extends RegistryRoof {
    registryType = 'aspectfilter';
    c_byName = new AspectFilterByName(this);
    c_byNameMultiple = new AspectFilterByNameMultiple(this);
    c_global = new AspectFilterGlobal(this);
    get registry_object() {
        return super.registry_object;
    }
}
